// src/features/system/edge-tasks/api/edgeTasksApi.ts
import { bff } from '@/lib/http/bff';

export type EdgeTaskStatus = 'pending' | 'claimed' | 'completed' | 'failed';

export interface EdgeTask {
  id: number;
  agentId: string | null;
  workflowKey: string;
  status: EdgeTaskStatus;
  statusLabel: string;
  inputs: Record<string, unknown>;
  result: Record<string, unknown> | null;
  errorMessage: string | null;
  claimedBy: string | null;
  claimedAt: string | null;
  completedAt: string | null;
  createdAt: string;
  durationMs: number | null;
}

export interface EdgeTaskListResponse {
  items: EdgeTask[];
  total: number;
}

export interface DispatchEdgeTaskParams {
  workflow_key: string;
  agent_id?: string;
  inputs?: Record<string, unknown>;
}

export const fetchEdgeTasks = (limit = 50, offset = 0): Promise<EdgeTaskListResponse> =>
  bff.get<EdgeTaskListResponse>('/orchestrator/edge-tasks', { limit, offset });

export const dispatchEdgeTask = (params: DispatchEdgeTaskParams): Promise<EdgeTask> =>
  bff.post<EdgeTask, DispatchEdgeTaskParams>('/orchestrator/edge-tasks', params);
